<template>
  <div class="About container-fluid">

    <div class="row topimages">
      <div class="col">
        <a href="#" target="_blank">
        <img src="@/assets/main/logMartine_v2.png">
        </a>
      </div>
    </div>
          <div class="row justify-content-md-center ">
      <div class="col-2 ">
       <a href="https://ca.linkedin.com/in/martinechapuis" target="_blank"> 
        <img class="rounded float-right" src="@/assets/interactive/mobile/linkedin.png">
        </a>
      </div>
      <div class="col-2 ">
        <a href="https://github.com/mchapuis" target="_blank">
        <img class="rounded float-left" src="@/assets/interactive/mobile/github.png">
        </a>

      </div>
    </div>
      <div class="col mainparagraph">
        <br>
            {{msg}}
      </div>

    <div class="row">
      <div class="col content">
            {{content1}}
            <br>
            {{content2}}
            <br>
            {{content3}}
            <br>
            {{content4}}
            <br><br><br>
            {{content5}}
            <br>
            {{content6}}
            <br>
            {{content7}}
            <br>
            {{content8}}
            <br><br><br>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'About',
  data: () =>({
    msg: "Hello, Bonjour",
    content1: "Martine Chapuis is a full stack developer and award-winning multidisciplinary artist, currently working as Web Developer for the Marketing team at Ubisoft Montreal. She previously worked in software development for the VFX film industry (Mill Film) and the image processing industry (Matrox)",
    content2:"She obtained both a bachelor's degree in computer science and in film animation from Concordia University. This dual expertise allows her to be fully autonomous when working on multimedia projects.",
    content3:"She received the DeSève award and a grant from Concordia for her work on the short film Let Me Out. She also produced the independent video game Chromatose and wrote several comics for the McGill French newspaper LeDélit.",
    content4:"At the moment, she is working on an innovative mobile game that supports mental health.",
    content5:"Martine Chapuis est une développeur full stack et une artiste multidisciplinaire primée, travaillant actuellement en tant que développeur Web pour l'équipe marketing d'Ubisoft Montréal. Elle a auparavant travaillé dans le développement de logiciels pour l'industrie cinématographique VFX (Mill Film) et l'industrie du traitement d'image (Matrox)",
    content6:"Elle a obtenu un baccalauréat en informatique ainsi qu'un baccalauréat en animation de films de l'Université Concordia. Cette double expertise lui permet d'être totalement autonome lorsqu'elle travaille sur des projets multimédias.",
    content7:"Elle a reçu le prix DeSève et une bourse de Concordia pour son travail sur le court métrage Let Me Out. Elle a également produit le jeu vidéo indépendant Chromatose et écrit plusieurs bandes dessinées pour le journal français McGill LeDélit.",
    content8:"En ce moment, elle travaille sur un jeu mobile innovant qui aide à la santé mentale."
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');

.About{
  margin: 5% 5% 5% 5%;
  font-family: 'Roboto', sans-serif;
  max-width: 700px;
}
.mainparagraph{
  text-align:center;
  font-weight: 600;
  margin-bottom: 2%;
}
.content{
  font-weight: 400;
  text-align: justify;
  margin-bottom: 5%;
  margin-left: 15%;
  margin-right:10%;
}
.images{
  text-align: left;
  margin-left: 10%;
  margin-right: 10%;
}
.topimages{
  text-align: center;
  margin-left: 10%;
  margin-right: 10%;
}

img{
  width:40%;
  height: auto;
}

</style>
